import { render, staticRenderFns } from "./widgetIframe.vue?vue&type=template&id=3af4037c&scoped=true"
import script from "./widgetIframe.vue?vue&type=script&lang=js"
export * from "./widgetIframe.vue?vue&type=script&lang=js"
import style0 from "./widgetIframe.vue?vue&type=style&index=0&id=3af4037c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af4037c",
  null
  
)

export default component.exports